/* nb-ask.js
   Ask nuviebaby widget. Both stores, no library. Each store's values (content files, WhatsApp
   number, support email, locale, currency) come from window.nbAskConfig, set per store in
   snippets/nb-ask-widget.liquid, so this file is the same on Singapore and Malaysia.
   Question and answer text comes only from the store's compiled content file
   (assets/nb-ask-content-<store>.json, or nb-ask-content-<store>-ms / -zh on a Malay or Chinese page), loaded on first open. Seed pill labels come from
   assets/nb-ask-seeds-<store>.json, a small extract of that same file, so the pills can render
   on the page without loading the full content.
   Contract: window.nbAsk.open({ nodeId, question }), window.nbAsk.close(), the
   cancelable `nb:ask` event from nb-ui.js, and [data-nb-ask-seeds="<page key>"] containers.
   The typed box routes by keyword and never writes text.
*/
(function () {
  'use strict';
  if (window.nbAsk && window.nbAsk.__ready) return;

  var CFG = window.nbAskConfig || {};
  // The store's active language: 'ms' or 'zh', '' for English. The snippet loads that language's content files;
  // the widget's own words come from UI, written here by cs-system/ask-nuviebaby/theme-assets.mjs from i18n/<lang>.json.
  var LANG = (CFG.lang === 'ms' || CFG.lang === 'zh') ? CFG.lang : '';
  var UI = /* nb-ask-ui:start */{"ms":{"Ask nuviebaby":"Tanya nuviebaby","Start over":"Mula semula","Close":"Tutup","Type a question":"Taip soalan","Send":"Hantar","Keep asking":"Tanya lagi","Message our team":"Hantar mesej kepada pasukan kami","Something else":"Perkara lain","None of these":"Tiada yang sesuai","Save {amount}":"Jimat {amount}","View product":"Lihat produk","Video guide":"Panduan video","From our blog":"Dari blog kami","Warranty":"Waranti","On our site":"Di laman kami","Support article":"Artikel sokongan","On this page":"Di halaman ini","{title} with today's price is in the card above.":"{title} dengan harga hari ini ada dalam kad di atas.","So far: {list}.":"Setakat ini: {list}.",", ":", "," and ":" dan ","Anything else you want to know?":"Ada apa-apa lagi yang anda ingin tahu?","What would you like to know about Clean Max?":"Apa yang anda ingin tahu tentang Clean Max?","What do you need help with?":"Anda perlukan bantuan tentang apa?","What would you like to know?":"Apa yang anda ingin tahu?","Type your question in your own words.":"Taip soalan anda dengan perkataan anda sendiri.","Here's what we have on that.":"Ini maklumat yang kami ada tentang perkara itu.","We don't have an answer for that one.":"Kami tiada jawapan untuk soalan itu.","Is one of these closer?":"Adakah salah satu daripada ini lebih hampir?","WhatsApp our team":"WhatsApp pasukan kami","Email our team":"E-mel pasukan kami","Complete your details below and we'll hand you over to our team.":"Lengkapkan butiran anda di bawah dan kami akan menyerahkan anda kepada pasukan kami.","Full name":"Nama penuh","First and last name":"Nama pertama dan nama akhir","Add your first and last name":"Masukkan nama pertama dan nama akhir anda","Email":"E-mel","The one you ordered with":"E-mel pesanan anda","Check your email address":"Semak alamat e-mel anda","Order number (optional)":"Nombor pesanan (pilihan)","Anything else to add?":"Ada apa-apa lagi untuk ditambah?","Your serial number and what needs changing":"Nombor siri anda dan apa yang perlu ditukar","Your serial number, and anything that helps us look into it":"Nombor siri anda, dan apa-apa yang membantu kami menyiasatnya","Details that help us look into it":"Butiran yang membantu kami menyiasatnya","Your email is ready. Press send, and add photos or video if they help.":"E-mel anda sudah sedia. Tekan hantar, dan tambah foto atau video jika ia membantu.","Your message is ready in WhatsApp. Press send, and add photos or video if they help.":"Mesej anda sudah sedia dalam WhatsApp. Tekan hantar, dan tambah foto atau video jika ia membantu.","We couldn't load Ask nuviebaby just now. Please try again in a moment.":"Kami tidak dapat memuatkan Tanya nuviebaby sekarang. Sila cuba lagi sebentar lagi.","Questions you can ask":"Soalan yang boleh anda tanya","Check my warranty":"Semak waranti saya","Serial number":"Nombor siri","Starts NBCL on the Clean and NBCM on Clean Max, followed by 10 digits":"Bermula dengan NBCL pada Clean dan NBCM pada Clean Max, diikuti 10 digit","The one you registered with":"E-mel pendaftaran waranti anda","We couldn't find a registration with those details. Check the serial number and the email you registered with, then try again.":"Kami tidak dapat mencari pendaftaran dengan butiran tersebut. Semak nombor siri dan e-mel yang anda gunakan semasa mendaftar, kemudian cuba lagi.","Register my warranty":"Daftar waranti saya","We have your registration and our team is still checking it.":"Kami telah menerima pendaftaran anda dan pasukan kami masih menyemaknya.","Extended warranty: {state}":"Waranti lanjutan: {state}","added":"ditambah","not added":"tidak ditambah","Your cover ended on {date}.":"Perlindungan anda tamat pada {date}.","Your cover starts on {start} and runs until {end}.":"Perlindungan anda bermula pada {start} dan berterusan sehingga {end}.","You're covered until {date}. That's {left} left.":"Anda dilindungi sehingga {date}. Tinggal {left} lagi.","less than a week":"kurang daripada seminggu","about {n} weeks":"kira-kira {n} minggu","about {n} months":"kira-kira {n} bulan","about {y} years":"kira-kira {y} tahun","about {y} years and {m} months":"kira-kira {y} tahun dan {m} bulan","Check the serial number. It starts NBCL or NBCM, followed by 10 digits.":"Semak nombor siri. Ia bermula dengan NBCL atau NBCM, diikuti 10 digit.","Check your email address.":"Semak alamat e-mel anda.","Checking":"Menyemak","That's a lot of checks from one connection. Please try again in an hour, or message our team.":"Terlalu banyak semakan daripada satu sambungan. Sila cuba lagi dalam masa sejam, atau hantar mesej kepada pasukan kami.","We couldn't run the check just now. Please try again, or message our team.":"Kami tidak dapat menjalankan semakan sekarang. Sila cuba lagi, atau hantar mesej kepada pasukan kami."},"zh":{"Ask nuviebaby":"问 nuviebaby","Start over":"重新开始","Close":"关闭","Type a question":"输入问题","Send":"发送","Keep asking":"继续提问","Message our team":"联系我们的团队","Something else":"其他问题","None of these":"都不是","Save {amount}":"省 {amount}","View product":"查看产品","Video guide":"视频教程","From our blog":"来自我们的博客","Warranty":"保修","On our site":"我们的网站","Support article":"支持文章","On this page":"本页内容","{title} with today's price is in the card above.":"{title} 的今日价格见上方卡片。","So far: {list}.":"到目前为止：{list}。",", ":"、"," and ":"和","Anything else you want to know?":"还有其他想了解的吗？","What would you like to know about Clean Max?":"关于 Clean Max，你想了解什么？","What do you need help with?":"你需要什么帮助？","What would you like to know?":"你想了解什么？","Type your question in your own words.":"用你自己的话输入问题。","Here's what we have on that.":"这是我们找到的相关信息。","We don't have an answer for that one.":"这个问题我们暂时没有答案。","Is one of these closer?":"这些中有更接近的吗？","WhatsApp our team":"通过 WhatsApp 联系我们的团队","Email our team":"发邮件给我们的团队","Complete your details below and we'll hand you over to our team.":"在下方填写你的资料，我们会帮你转接给我们的团队。","Full name":"姓名","First and last name":"名字和姓氏","Add your first and last name":"请填写你的名字和姓氏","Email":"邮箱","The one you ordered with":"下单时使用的邮箱","Check your email address":"请检查你的邮箱地址","Order number (optional)":"订单号（选填）","Anything else to add?":"还有其他要补充的吗？","Your serial number and what needs changing":"你的序列号以及需要修改的内容","Your serial number, and anything that helps us look into it":"你的序列号，以及任何有助于我们调查的信息","Details that help us look into it":"有助于我们调查的详细信息","Your email is ready. Press send, and add photos or video if they help.":"你的邮件已准备好。点击发送，如有帮助可附上照片或视频。","Your message is ready in WhatsApp. Press send, and add photos or video if they help.":"你的消息已在 WhatsApp 中准备好。点击发送，如有帮助可附上照片或视频。","We couldn't load Ask nuviebaby just now. Please try again in a moment.":"暂时无法加载“问 nuviebaby”。请稍后再试。","Questions you can ask":"你可以问的问题","Check my warranty":"查询我的保修","Serial number":"序列号","Starts NBCL on the Clean and NBCM on Clean Max, followed by 10 digits":"Clean 以 NBCL 开头，Clean Max 以 NBCM 开头，后跟 10 位数字","The one you registered with":"注册保修时使用的邮箱","We couldn't find a registration with those details. Check the serial number and the email you registered with, then try again.":"未找到与这些信息匹配的注册记录。请检查序列号和注册时使用的邮箱，然后重试。","Register my warranty":"注册我的保修","We have your registration and our team is still checking it.":"我们已收到你的注册，我们的团队仍在审核中。","Extended warranty: {state}":"延长保修：{state}","added":"已添加","not added":"未添加","Your cover ended on {date}.":"你的保修已于 {date} 结束。","Your cover starts on {start} and runs until {end}.":"你的保修从 {start} 开始，到 {end} 结束。","You're covered until {date}. That's {left} left.":"你的保修有效期至 {date}。还剩{left}。","less than a week":"不到一周","about {n} weeks":"约 {n} 周","about {n} months":"约 {n} 个月","about {y} years":"约 {y} 年","about {y} years and {m} months":"约 {y} 年 {m} 个月","Check the serial number. It starts NBCL or NBCM, followed by 10 digits.":"请检查序列号。它以 NBCL 或 NBCM 开头，后跟 10 位数字。","Check your email address.":"请检查你的邮箱地址。","Checking":"查询中","That's a lot of checks from one connection. Please try again in an hour, or message our team.":"来自同一连接的查询次数过多。请一小时后再试，或联系我们的团队。","We couldn't run the check just now. Please try again, or message our team.":"暂时无法查询。请重试，或联系我们的团队。"}}/* nb-ask-ui:end */;
  function t(s, v) {
    var o = (LANG && UI[LANG] && UI[LANG][s]) || s;
    return v ? o.replace(/\{(\w+)\}/g, function (m, k) { return k in v ? v[k] : m; }) : o;
  }
  window.nbAskT = t;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';   // '/ms/' or '/zh/' on a translated page
  var KEY = 'nb-ask-v4' + (LANG ? '-' + LANG : '');   // a thread in one language does not reopen in another
  var WA_NUMBER = CFG.whatsapp || '6588202545';
  var SUPPORT_EMAIL = CFG.email || 'support@nuviebaby.com';
  var LOCALE = CFG.locale || 'en-SG';
  var MACHINE_HANDLE = 'nuviebaby-clean-max';
  var ID_DOOR = 'clean-owners.door.start';       // "Do you already have a nuviebaby machine?"
  var ID_WHICH = 'clean-owners.door.have-one';   // "Which one?"
  var SP = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 0l1.6 4.4L14 6l-4.4 1.6L8 12l-1.6-4.4L2 6l4.4-1.6zM13 10l.8 2.2 2.2.8-2.2.8L13 16l-.8-2.2L10 13l2.2-.8z"/></svg>';
  var BUBBLE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 5.5C4 4.67 4.67 4 5.5 4h13c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5H10l-4.2 3.6c-.4.34-1-.04-1-.55V16H5.5C4.67 16 4 15.33 4 14.5v-9z"/></svg>';
  var X_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3L13 13M13 3L3 13" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>';
  var RESET_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20 4v5h-5"/></svg>';
  var SEND_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PLAY_ICON = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 1l8 5-8 5V1z"/></svg>';
  var DOC_ICON = '<svg viewBox="0 0 12 14" aria-hidden="true" focusable="false"><path d="M1 0h7l3 3v11H1V0z" fill="none" stroke="currentColor" stroke-width="1.25"/></svg>';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = null;          // full compiled content, loaded on first open
  var SD = null;         // seeds extract
  var contentPromise = null;
  var seedsPromise = null;
  var ui = null;
  var busy = false;
  var returnFocus = null;
  var walking = false;   // test walker: no network for cards
  var gen = 0;           // bumped by Start over so an in-flight reply stops writing into the cleared thread
  var ABORT = 'nb-abort';
  var S = load() || fresh();

  /* ------------------------------------------------------------ state */
  // offered: how many times each question has been put in a follow-up row. nAns: answers given so far.
  // nShop: how many of them were shopping answers. moment: nAns when the "So far" card last showed (-1: not yet).
  // pend: a buying signal is waiting for the next answer that ends a branch.
  function fresh() { return { path: [], run: 0, facts: [], shown: {}, cards: {}, thread: '', typed: '', machine: '', cur: '', auto: '', offered: {}, lastRow: [], seen: {}, nAns: 0, nShop: 0, moment: -1, pend: 0 }; }
  function load() {
    try {
      var v = JSON.parse(sessionStorage.getItem(KEY));
      if (!v || typeof v !== 'object') return null;
      var f = fresh();
      Object.keys(f).forEach(function (k) { if (!(k in v)) v[k] = f[k]; });
      return v;
    } catch (e) { return null; }
  }
  function save() {
    if (!ui) return;
    try {
      var clone = ui.thread.cloneNode(true);
      qa('.nb-ask__typing', clone).forEach(function (n) { n.remove(); });
      S.thread = clone.innerHTML;
      sessionStorage.setItem(KEY, JSON.stringify(S));
    } catch (e) { /* storage blocked: the widget still works, the thread just will not carry across pages */ }
  }

  /* ------------------------------------------------------------ helpers */
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, reduced ? 0 : ms); }); }
  /* ------------------------------------------------------------ tracking
     Anonymous tap tracking into Supabase table ask_events (insert-only for the public key). Never sends a name,
     email, order number, phone or the handoff note. Typed text is redacted here and refused by the database if
     anything personal is left. Honours Shopify's Customer Privacy API. A failure never touches the widget. */
  var TRK = { q: [], timer: 0, sid: '', wired: false };
  function trkSession() {
    if (TRK.sid) return TRK.sid;
    try { TRK.sid = sessionStorage.getItem('nb-ask-sid') || ''; } catch (e) { /* storage blocked */ }
    if (!TRK.sid) {
      TRK.sid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
      try { sessionStorage.setItem('nb-ask-sid', TRK.sid); } catch (e) { /* storage blocked */ }
    }
    return TRK.sid;
  }
  function trkAllowed() {
    if (!CFG.trackUrl || !CFG.trackKey) return false;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) { return false; }
    return true;   // no consent API on this page
  }
  function redact(t) {
    t = String(t || '')
      .replace(/[^\s@]+@[^\s@]+/g, ' ')
      .replace(/#\s*\d+/g, ' ')
      .replace(/\b[A-Za-z]{0,4}-?\d{4,}\b/g, ' ')
      .replace(/\d(?:\D{0,2}\d){6,}/g, ' ')
      .replace(/@/g, ' ')
      .replace(/\s+/g, ' ').trim();
    return t.slice(0, 200);
  }
  function trkFlush(unload) {
    clearTimeout(TRK.timer); TRK.timer = 0;
    if (!TRK.q.length) return;
    var rows = TRK.q.splice(0, 50);
    if (!trkAllowed()) return;   // not consented: dropped, never queued for later
    try {
      fetch(CFG.trackUrl, {
        method: 'POST', keepalive: true, credentials: 'omit',
        headers: { 'Content-Type': 'application/json', 'apikey': CFG.trackKey, 'Prefer': 'return=minimal' },
        body: JSON.stringify(rows)
      }).catch(function () { /* unreachable: the widget carries on */ });
    } catch (e) { /* tracking never blocks the widget */ }
    if (TRK.q.length) TRK.timer = setTimeout(trkFlush, 1000);
  }
  function emit(event, f) {
    if (walking || !CFG.trackUrl) return;
    try {
      f = f || {};
      if (!TRK.wired) {
        TRK.wired = true;
        window.addEventListener('pagehide', function () { trkFlush(true); });
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') trkFlush(true); });
      }
      var row = {
        store: CFG.store === 'my' ? 'my' : 'sg',
        session_id: trkSession(),
        page: (location.pathname || '/').slice(0, 200),
        event: event,
        node_id: f.node_id ? String(f.node_id).slice(0, 120) : null,
        entry: f.entry || null,
        machine: S && (S.machine === 'clean' || S.machine === 'clean-max') ? S.machine : '',
        typed_text: f.typed_text != null ? redact(f.typed_text) : null,
        target: f.target ? String(f.target).replace(/^https?:\/\/[^/]+/, '').replace(/[?#].*$/, '').slice(0, 300) : null,
        meta: f.meta || null
      };
      if ((window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || /[?&]preview_theme_id=/.test(location.search)) row.meta = Object.assign({}, row.meta || {}, { preview: true });
      if (f.target && /#/.test(String(f.target)) && /^section:/.test(String(f.target))) row.target = String(f.target).slice(0, 300);
      TRK.q.push(row);
      if (TRK.q.length >= 20) trkFlush(); else if (!TRK.timer) TRK.timer = setTimeout(trkFlush, 5000);
    } catch (e) { /* tracking never blocks the widget */ }
  }
  var ENTRY = { launcher: 'launcher', seed: 'teaser', 'pdp-pill': 'teaser', event: 'card', composer: 'typed' };
  function track(name, d) {
    d = d || {};
    try { if (window.nbAsk && typeof window.nbAsk.track === 'function') window.nbAsk.track(name, d); } catch (e) { /* optional page hook */ }
    switch (name) {
      case 'widget_open': emit('open', { entry: ENTRY[d.source] || null }); break;
      case 'widget_close': emit('close', { node_id: S.cur }); break;
      case 'node_view': emit('node_view', { node_id: d.node }); break;
      case 'pill_tap': emit('pill_tap', { node_id: d.node }); break;
      case 'typed_matched': emit('typed_match', { node_id: d.node || S.cur, typed_text: d.text, entry: 'typed' }); break;
      case 'typed_unmatched': emit('typed_unmatched', { node_id: S.cur, typed_text: d.text, entry: 'typed' }); break;
      case 'card_view': emit('card_view', { node_id: S.cur, target: d.target || (d.kind === 'section' ? 'section:' + d.anchor : d.kind), meta: { kind: d.kind } }); break;
      case 'card_click': emit('card_click', { node_id: S.cur, target: d.target, meta: { kind: d.kind || '' } }); break;
      case 'section_scroll': emit('card_click', { node_id: S.cur, target: 'section:' + d.to, meta: { kind: 'section' } }); break;
      case 'hub_click': emit('card_click', { node_id: S.cur, target: 'hub', meta: { kind: 'hub' } }); break;
      case 'recap_shown': emit('moment_shown', { node_id: S.cur }); break;
      case 'keep_asking': emit('keep_asking', { node_id: S.cur }); break;
      case 'handoff_open': emit('handoff_shown', { node_id: S.cur, meta: { issue: String(d.issue || '').slice(0, 80) } }); break;
      case 'handoff_send': emit(d.channel === 'email' ? 'handoff_email' : 'handoff_whatsapp', { node_id: S.cur, meta: { issue: String(d.issue || '').slice(0, 80) } }); break;
      case 'tool_result': emit('card_click', { node_id: S.cur, target: 'tool:' + String(d.tool || ''), meta: { kind: 'tool', tool: String(d.tool || ''), result: String(d.result || '') } }); break;
      case 'start_over': emit('start_over', { entry: 'start_over' }); break;
    }
  }
  function isPhone() { return window.matchMedia('(max-width: 899px)').matches; }

  /* ------------------------------------------------------------ machine carried in state */
  // A picker is a machine-neutral node whose only children are one-per-machine ("Which machine do
  // you have?"). Once the machine is known, a picker is never asked: the child for that machine plays.
  function isPicker(n) {
    if (!n || n.machine) return false;
    var ms = (n.next || []).filter(function (x) { return D.G[x]; }).map(function (x) { return D.G[x].machine; });
    if (ms.length < 2) return false;
    return ms.every(function (m) { return m === 'clean' || m === 'clean-max'; }) && ms.indexOf('clean') >= 0 && ms.indexOf('clean-max') >= 0;
  }
  function machineKid(ids, m) {
    for (var i = 0; i < ids.length; i++) { if (D.G[ids[i]] && D.G[ids[i]].machine === m) return ids[i]; }
    return '';
  }
  // a signpost target; {machine} is the machine the customer picked earlier
  function resolveGoto(g) {
    if (g.indexOf('{machine}') >= 0) {
      if (!S.machine) return '';
      g = g.replace('{machine}', S.machine);
    }
    return D.G[g] ? g : '';
  }

  /* ------------------------------------------------------------ content */
  function loadContent() {
    if (D) return Promise.resolve(D);
    if (!contentPromise) {
      contentPromise = fetch(CFG.contentUrl).then(function (r) {
        if (!r.ok) throw new Error('content ' + r.status);
        return r.json();
      }).then(function (d) { D = d; buildIndex(); return d; }).catch(function (err) { contentPromise = null; throw err; });
    }
    return contentPromise;
  }
  function loadSeeds() {
    if (D) return Promise.resolve({ SEEDS: D.SEEDS || {}, RETIRED: D.RETIRED || [], Q: null });
    if (SD) return Promise.resolve(SD);
    if (!seedsPromise) {
      seedsPromise = fetch(CFG.seedsUrl).then(function (r) {
        if (!r.ok) throw new Error('seeds ' + r.status);
        return r.json();
      }).then(function (d) { SD = d; return d; }).catch(function () { seedsPromise = null; return { SEEDS: {}, RETIRED: [], Q: {} }; });
    }
    return seedsPromise;
  }
  function pageKey(requested) {
    var seeds = (D && D.SEEDS) || (SD && SD.SEEDS) || {};
    var k = requested || CFG.page || '';
    if (seeds[k]) return k;
    return k === 'home' ? 'cleanmax' : 'support';
  }
  function seedIds(key, src) {
    var seeds = src.SEEDS || {};
    var retired = {};
    (src.RETIRED || []).forEach(function (r) { retired[r] = 1; });
    var list = (seeds[pageKey(key)] || []).slice().sort(function (a, b) { return a[0] - b[0]; });
    return list.map(function (x) { return x[1]; }).filter(function (id) { return !retired[id]; });
  }
  function label(id) {
    if (D && D.G[id]) return D.G[id].q;
    if (SD && SD.Q && SD.Q[id]) return SD.Q[id];
    return '';
  }
  function pageSeeds(n, key) {
    var ids = seedIds(key || CFG.page, D || SD || {}).filter(function (id) { return D ? !!D.G[id] : true; });
    return typeof n === 'number' ? ids.slice(0, n) : ids;
  }

  /* ------------------------------------------------------------ seed pills on the page */
  function fillSeeds(root) {
    qa('[data-nb-ask-seeds]', root).forEach(function (el) {
      var key = el.getAttribute('data-nb-ask-seeds');
      if (!key || el.getAttribute('data-nb-ask-seeded')) return;
      el.setAttribute('data-nb-ask-seeded', '1');
      loadSeeds().then(function (src) {
        var ids = seedIds(key, src);
        var limit = parseInt(el.getAttribute('data-nb-ask-limit'), 10) || 8;
        ids = ids.filter(function (id) { return src.Q ? !!src.Q[id] : !!(D && D.G[id]); }).slice(0, limit);
        if (!ids.length) { el.removeAttribute('data-nb-ask-seeded'); return; }
        var onCobalt = !!el.closest('.bg-cobalt');
        el.innerHTML = ids.map(function (id) {
          var q = src.Q ? src.Q[id] : D.G[id].q;
          return '<button type="button" class="nb-ask-seed' + (onCobalt ? ' nb-ask-seed--cobalt' : '') + '" data-nb-ask-node="' + esc(id) + '">' + SP + '<span>' + esc(q) + '</span></button>';
        }).join('');
      });
    });
  }

  /* ------------------------------------------------------------ router */
  var SYN = {
    spoil: 'broken', spoilt: 'broken', rosak: 'broken', cannot: 'not working', wont: 'not working', doesnt: 'not working', kaput: 'broken',
    wet: 'damp', moist: 'damp', stain: 'spots', residue: 'spots', chalky: 'spots', white: 'spots', kerak: 'descale', limescale: 'descale',
    smelly: 'smell', odour: 'smell', odor: 'smell', stink: 'smell', leaking: 'leak', leaks: 'leak', noisy: 'noise', loud: 'noise',
    deliver: 'delivery', shipping: 'delivery', ship: 'delivery', parcel: 'order', courier: 'order', refund: 'claim', guarantee: 'warranty',
    harga: 'price', cost: 'price', expensive: 'price', promo: 'price', discount: 'price', bundle: 'price',
    sterilize: 'sterilise', sterilizer: 'sterilise', steriliser: 'sterilise', uv: 'sterilise', boil: 'sterilise', boiling: 'sterilise',
    capacity: 'bottles', hexa: 'hepa', filter: 'hepa', install: 'setup', plumbing: 'setup', purchase: 'buy', get: 'buy',
    detergent: 'tablets', soap: 'tablets', tab: 'tablets', tabs: 'tablets', breast: 'pump', flange: 'pump', spectra: 'pump', medela: 'pump',
    wifi: 'app', bluetooth: 'app', drying: 'dry', dryer: 'dry', burn: 'hot', serial: 'register'
  };
  var STOP = {};
  ('a an the is are am i my me you your it its to of in on at for and or do does did can could would should will what how when where why which who ' +
   'this that these those with without if be have has had there any some about from as by just so than then also got us we our too very ' +
   'please hi hello yes later soon now yet again really actually quickly ' +
   'apa ada saya boleh ke di yang dan untuk ini itu dengan ia anda kami kita adakah sudah dah lagi juga atau dari pada nak macam bagaimana tolong').split(' ').forEach(function (w) { STOP[w] = 1; });
  // Chinese has no spaces: a run of characters is read as overlapping pairs ("会不会很吵" -> 会不 不会 会很 很吵), minus pairs that say nothing
  var CJK = /[㐀-鿿]+/g;
  var STOPZ = {};
  '什么 怎么 可以 是不 不是 我的 我们 你们 这个 那个 一个 有没 请问 的吗'.split(' ').forEach(function (w) { STOPZ[w] = 1; });
  var IDX = null;
  var TOP = {};   // questions a visitor can ask outright: seeded on a page, or not reachable only through another node
  var PARENTS = {};   // node id -> the nodes that list it as a child
  var QPILL = {};   // nodes whose pill is a question that stands on its own

  function stem(w) {
    if (w.length > 5 && /ing$/.test(w)) return w.slice(0, -3);
    if (w.length > 4 && /es$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function toks(s) {
    var out = [];
    s = String(s || '').toLowerCase().replace(CJK, function (run) {
      if (run.length === 1) out.push(run);
      for (var i = 0; i < run.length - 1; i++) { var p = run.substr(i, 2); if (!STOPZ[p]) out.push(p); }
      return ' ';
    });
    s.replace(/['’]/g, '').replace(/[^a-z0-9\s]/g, ' ').split(/\s+/).forEach(function (w) {
      if (!w) return;
      var m = SYN[w] || w;
      m.split(' ').forEach(function (x) { if (x && !STOP[x]) out.push(stem(x)); });
    });
    return out;
  }
  function buildIndex() {
    var seeded = {};
    Object.keys(D.SEEDS || {}).forEach(function (p) { D.SEEDS[p].forEach(function (x) { seeded[x[1]] = 1; }); });
    var child = {};
    PARENTS = {};
    Object.keys(D.G).forEach(function (id) { (D.G[id].next || []).forEach(function (c) { child[c] = 1; (PARENTS[c] = PARENTS[c] || []).push(id); }); });
    TOP = {};
    Object.keys(D.G).forEach(function (id) { var g = D.G[id]; if (!g.goto && !g.handoff && (seeded[id] || !child[id])) TOP[id] = 1; });
    // a pill that is itself a question reads on its own ("Can I pause it or cancel it?"); a context answer ("Yes, I pump", "On this website") does not
    QPILL = {};
    Object.keys(D.G).forEach(function (id) {
      var g = D.G[id];
      if (!g.goto && !g.handoff && (g.a || []).length && /\?\s*$/.test(g.q)) QPILL[id] = 1;
    });
    var docs = {}, df = {}, N = 0;
    Object.keys(D.G).forEach(function (id) {
      var n = D.G[id];
      if (n.goto) return;   // a signpost is a menu label, the node it points to is what a question should find
      var w = {};
      function add(list, weight) { list.forEach(function (t) { if (!w[t] || w[t] < weight) w[t] = weight; }); }
      add(toks((n.a || []).join(' ')), 0.5);
      add(toks(id.split('.').slice(1).join(' ').replace(/-/g, ' ')), 2);
      add(toks(n.issue || ''), 2);
      add(toks(n.q), 3);
      if (n.qe) add(toks(n.qe), 3);   // a translated page still finds a question typed in English
      docs[id] = { w: w, machine: n.machine || '', qtoks: toks(n.q), boost: (seeded[id] ? 1.4 : 1) * (toks(n.q).length <= 1 ? 0.5 : toks(n.q).length <= 2 ? 0.7 : 1) * (child[id] ? 0.85 : 1.15) };
      Object.keys(w).forEach(function (t) { df[t] = (df[t] || 0) + 1; });
      N++;
    });
    var idf = {};
    Object.keys(df).forEach(function (t) { idf[t] = Math.log(1 + N / df[t]); });
    IDX = { docs: docs, idf: idf, n: N };
  }
  function route(text) {
    if (!IDX) return [];
    var q = toks(text);
    var zh = /[㐀-鿿]/.test(text);
    var seen = {};
    q = q.filter(function (t) { if (seen[t]) return false; seen[t] = 1; return true; });
    if (!q.length) return [];
    var unknown = Math.log(1 + IDX.n);
    var total = 0;
    q.forEach(function (t) { total += IDX.idf[t] || unknown; });
    var scores = [];
    Object.keys(IDX.docs).forEach(function (id) {
      var d = IDX.docs[id], s = 0, strong = 0, got = 0;
      q.forEach(function (t) {
        if (d.w[t]) { s += d.w[t] * IDX.idf[t]; got += IDX.idf[t]; if (d.w[t] >= 2) strong++; }
      });
      if (!strong) return;
      var cov = got / total;
      if (cov < (zh ? 0.34 : 0.6)) return;                           // character pairs overlap, so a Chinese question shares fewer of them
      if (q.length >= 3 && strong < 2) return;                       // most of what they typed must be found in the node
      var qt = d.qtoks, inQ = qt.length && qt.every(function (t) { return seen[t]; });
      s = s * d.boost * (inQ ? 1.5 : 1) * (0.6 + cov);
      if (S.machine && d.machine) s *= (d.machine === S.machine ? 1.25 : 0.6);   // their machine's answer first
      scores.push([id, s, strong, cov]);
    });
    scores.sort(function (a, b) { return b[1] - a[1]; });
    var floor = q.length === 1 ? 4 : 5;
    return scores.filter(function (x) { return x[1] >= floor; }).slice(0, 3);
  }
  /* topic overrides: common phrasings (incl. Singlish/Manglish) that must land on a known node.
     t = node for any machine, c / m = node for Clean / Clean Max (fall back to t). t may be a machine question when the machine matters. */
  var TOPICS = [
    { re: /\bberapa lama\b.*\bkitaran\b|(洗|清洗)(一次|一轮|一遍).*(多久|多长时间)|(程序|周期).*(多久|多长时间)/, t: 'clean-max-pre-sale.cycles.how-long' },
    { re: /\b(bundles?|packs?)\b.*\b(refills?|tablets?|filters?|hepa|descal\w*)\b.*\b(ship|ships|shipped|arrive|arrives|deliver\w*|together|with)\b|\b(refills?|tablets?|filters?)\b.*\b(in|from) (a|the|my) bundle\b.*\b(ship|arrive|deliver\w*|together|with)\b|\brefills?\b.*\b(ship|arrive|deliver\w*)\b.*\b(together|with)\b/, t: 'clean-max-pre-sale.delivery.bundle-refills' },
    { re: /^(?!.*\bmy (order|parcel|package|delivery)\b)(?=.*\b(ship|ships|shipping|arrive|arrives|arrival|dispatch|dispatched|delivered|deliver)\b)(?=.*\b(when|what date|which date|how soon)\b)(?=.*\b(it|clean max|cleanmax|they|pre[- ]?order)\b).*$|\bpre[- ]?order (date|dates|delivery|shipping|timeline)\b|\bbila (sampai|tiba|hantar)\b/, t: 'clean-max-pre-sale.delivery.when-ship' },
    { re: /\bpre[- ]?orders?\b|\bwhen (can|will) i (get|buy|order)\b/, t: 'clean-max-pre-sale.price.overview' },
    { re: /\bin the box\b|\bwhat('?s| is) included\b|\bcomes with\b|\bbox contents\b|\bdalam kotak\b|包装里|盒子里|包含什么|配件有哪些/, t: 'clean-max-pre-sale.box.overview', m: 'clean-max-owners.setup.whats-in-box' },
    { re: /\b(steam boost|jets?)\b|\bhow well\b.*\bclean|\bdried[- ]on milk\b/, t: 'clean-max-pre-sale.cleaning.overview' },
    { re: /\bhow many bottles\b|\bnumber of bottles\b|\bbottle capacity\b|\bcapacity\b|\bberapa (banyak )?botol\b|几个奶瓶|多少个奶瓶|容量/, t: 'clean-max-pre-sale.will-it-fit.overview' },
    { re: /\b(difference|different|better|compare|compared|versus|vs)\b.*\bclean\b|\bclean\b.*\b(vs|versus)\b|\bbeza\w*\b.*\bclean\b|clean.*(区别|不同|差别)|(区别|不同|差别).*clean/, t: 'clean-max-pre-sale.difference-from-clean.overview' },
    { re: /\bregister\b.*\bwarranty\b|\bwarranty\b.*\bregist/, t: 'clean-owners.warranty.register' },
    { re: /^\s*(return|returns|how do i return)\s*$/, t: 'orders-and-delivery.returns-and-refunds.returns-refunds' },
    { re: /^(?!.*\b(refill|tablets?|hepa|filter|hose|descal\w*|pack|warranty|part|spare|delivery|shipping|lama|cepat|penghantaran|hantar|sampai)\b)(?!.*(配送|发货|运费|滤网|清洗片|除垢|保修))(?:.*\b(prices?|pricing|how much|cost|costs|berapa|harga|expensive|cheap)\b|.*(多少钱|价格|价钱|几钱|贵不贵))/, t: 'clean-max-pre-sale.price.overview' },
    { re: /\b(shopee|lazada|tiktok|tik tok)\b/, t: 'orders-and-delivery.delivery-timeframes.ordered-marketplace' },
    { re: /\bwarranty\b.*\b(long|length|years?|period|last|cover)\b|\b(how long|how many years?|how many months?)\b.*\bwarranty\b|\bwarranty (length|period|duration)\b|\bwaranti\b.*\b(berapa|lama|tahun)\b|保修.*(多久|几年|多长)/, t: 'clean-owners.warranty.coverage' },
    { re: /\bspecial (washing )?tablets?\b|\bwashing tablets?\b.*\b(need|special|required)\b|\bneed.*tablets?\b|\btablet\b.*\b(khas|perlu)\b|\bperlu\b.*\btablet\b|专用清洗片|需要.*清洗片/, t: 'tablets-and-descaler.washing-tablets.overview' },
    { re: /\b(fit|fits|fitting)\b.*\b(bottle|bottles|avent|dr browns|dr brown|philips|pigeon|comotomo|mam|nuk|medela|tommee|chicco|spectra|haakaa)\b|\b(avent|dr browns|dr brown|philips|pigeon|comotomo|mam|nuk|tommee|chicco)\b.*\bfit|\bbotol\b.*\bmuat\b|奶瓶.*(放得下|放不下|装得下|适用|兼容)/, t: 'clean-max-pre-sale.will-it-fit.overview' },
    { re: /\b(loud|noisy|noise|bising|quiet|senyap|decibel|db)\b|吵|噪音|噪声|声音大|分贝/, t: 'clean-max-pre-sale.noise.overview' },
    { re: /\b(leak(s|ing|ed)?|bocor|dripping|puddle)\b|\brosak\b|\bbroken\b|\bspoil(t|ed)?\b|\bkaput\b|漏水|坏了|故障|不能用|不工作/, t: 'clean-owners.door.have-one', c: 'clean-owners.entry.something-wrong', m: 'clean-max-owners.entry.something-wrong' },
    { re: /\b(buy|order|purchase|where to get|beli)\b.*\b(filter|hepa)\b|\b(filter|hepa|penapis)\b.*\b(buy|price|beli|purchase|harga)\b|(买|购买|价格).*滤网|滤网.*(买|购买|价格|多少钱)/, t: 'orders-and-delivery.stock-and-refills.buy-filters' },
    { re: /\b(drain|draining)\s*(hose|pipe|tube)\b|\bhose\b|\bhos\b|\bdrain pipe\b|\bpaip\b|排水管|水管/, t: 'accessories.drain-hose.not-in-a-pack' },
    { re: /\b(hepa|hexa)\b|\bfilter\b|\bpenapis\b|滤网|过滤/, t: 'clean-owners.hepa.when-and-how', c: 'clean-owners.maintenance.change-filter', m: 'clean-max-owners.maintenance.change-filter' },
    { re: /\brust(y|ing|ed)?\b|\bkarat\b|\bberkarat\b|\bcorrod|\boxidi[sz]|生锈|锈/, t: 'clean-owners.door.have-one', c: 'faults.part-broken.clean.rust', m: 'faults.entry.something-wrong' },
    { re: /\b(wet|damp|moist|basah|lembap)\b|\bnot\s*(fully\s*|completely\s*|properly\s*)?(dry|drying|kering)\b|\b(isnt|arent|doesnt|dont|wont|never)\s+(fully\s+|properly\s+)?dry|\bwater (droplets|left|inside|on)\b|\bdry (properly|fully)\b|\b(tak|xde|x)\s*kering\b|\bsmell(y|s|ing)?\b|\b(ber)?bau\b|\bbusuk\b|\bstink(s|y)?\b|\bodou?r\b|\bmusty\b|\bmou?ldy\b|\bmou?ld\b|\bfishy\b|湿|没干|不干|水珠|臭|异味|发霉/, t: 'clean-owners.door.drying' },
    { re: /\b(wheres|where is|where my|track(ing)?|status|check)\b.*\b(order|parcel|package|delivery|shipment|item)\b|\b(order|parcel|package|delivery)\s*(status|tracking|update)\b|\bwhen\b.*\b(arrive|arrives|arrival|deliver|delivered|delivery|come|reach|receive|dispatched|shipped)\b|\bwhen will\b|\bnot (yet )?(arrive|arrived|received|here)\b|\bhavent (got|received)\b|\bstill waiting\b|\bmana\b.*\b(order|barang|parcel|pesanan)\b|\bdelayed?\b|(订单|包裹).*(哪|状态|还没|到了|查)|还没(收到|到)|什么时候到/, t: 'orders-and-delivery.delivery-timeframes.when-arrive' },
    { re: /\bdeliver(y|ies|ed)?\b|\bshipping\b|\bships?\b|\bshipped\b|\bcourier\b|\bhantar\b|\bpenghantaran\b|配送|送货|发货|快递|运送|几天到/, t: 'orders-and-delivery.delivery-timeframes.how-fast-' + (CFG.store === 'my' ? 'my' : 'sg') }
  ];
  function topicRoute(text) {
    var q = String(text || '').toLowerCase().replace(/['’]/g, '');
    for (var i = 0; i < TOPICS.length; i++) {
      if (!TOPICS[i].re.test(q)) continue;
      var T = TOPICS[i], id = (S.machine === 'clean' && T.c) || (S.machine === 'clean-max' && T.m) || T.t;
      if (id && D.G[id]) return id;
    }
    return '';
  }
  function normQ(s) { return toks(s).join(' '); }
  // static page pills whose wording differs from the node's own pill text
  var ALIAS_LIST = [
    ['Do I need special tablets?', 'tablets-and-descaler.washing-tablets.overview']
  ];
  function resolveQuestion(text) {
    var n = normQ(text);
    if (!n) return null;
    for (var a = 0; a < ALIAS_LIST.length; a++) { if (normQ(ALIAS_LIST[a][0]) === n && D.G[ALIAS_LIST[a][1]]) return ALIAS_LIST[a][1]; }
    var ids = Object.keys(D.G);
    var same = ids.filter(function (id) { return !D.G[id].goto && (normQ(D.G[id].q) === n || (D.G[id].qe && normQ(D.G[id].qe) === n)); });   // qe: the English pill, for page pills written in English
    if (same.length) {
      // two nodes can share a pill (a shopper's and an owner's): the visitor's own machine decides
      var mine = same.filter(function (id) { return S.machine ? D.G[id].machine === S.machine : /^clean-max-pre-sale\./.test(id); });
      return (mine[0] || same[0]);
    }
    var hits = route(text);
    if (!hits.length) return null;
    // a pill typed on the page must really be that question, not just share a word with it
    var a = toks(text), b = IDX.docs[hits[0][0]].qtoks;
    var common = a.filter(function (t) { return b.indexOf(t) >= 0; }).length;
    return (common / Math.max(a.length, b.length) >= 0.5 || hits[0][1] >= 30) ? hits[0][0] : null;
  }

  /* ------------------------------------------------------------ panel DOM */
  var inl = null;   // the inline Questions panel on this page, if any: { host, body, form, input, key }
  function restore() {
    if (ui.__restored) return;
    ui.__restored = true;
    ui.thread.innerHTML = S.thread || '';
    syncReset();
    resetHandoffs();
    ui.thread.addEventListener('click', onHandoffClick);
  }
  // One thread element serves both surfaces: it sits in the inline panel until the slide-out opens,
  // then moves into the slide-out, and moves back when that closes. Same DOM, same state.
  function place(where) {
    if (!ui) return;
    if (where === 'inline' && inl) { inl.body.appendChild(ui.thread); ui.where = 'inline'; }
    else { ui.panel.insertBefore(ui.thread, ui.form); ui.where = 'panel'; }
    scrollDown();
  }
  function curInput() { return (ui && ui.where === 'inline' && inl) ? inl.input : (ui && ui.input); }
  function buildUI() {
    if (ui) return ui;
    var root = document.createElement('div');
    root.className = 'nb-ask';
    root.id = 'nb-ask';
    root.innerHTML =
      '<div class="nb-ask__scrim" data-nb-ask-close></div>' +
      '<section class="nb-ask__panel" role="dialog" aria-modal="true" aria-labelledby="nb-ask-title" tabindex="-1" aria-hidden="true">' +
        '<header class="nb-ask__head">' +
          '<div class="nb-ask__brand">' + BUBBLE_ICON + '<h2 class="nb-ask__title" id="nb-ask-title">' + esc(t('Ask nuviebaby')) + '</h2></div>' +
          '<div class="nb-ask__actions"><button type="button" class="nb-ask__reset" data-nb-ask-reset aria-label="' + esc(t('Start over')) + '" title="' + esc(t('Start over')) + '">' + RESET_ICON + '</button>' +
          '<button type="button" class="nb-ask__close" data-nb-ask-close aria-label="' + esc(t('Close')) + '">' + X_ICON + '</button></div>' +
        '</header>' +
        '<div class="nb-ask__thread" role="log" aria-live="polite"></div>' +
        '<form class="nb-ask__composer" autocomplete="off">' +
          '<input class="nb-ask__input" type="text" maxlength="240" placeholder="' + esc(t('Type a question')) + '" aria-label="' + esc(t('Type a question')) + '">' +
          '<button class="nb-ask__send" type="submit" aria-label="' + esc(t('Send')) + '">' + SEND_ICON + '</button>' +
        '</form>' +
      '</section>';
    document.body.appendChild(root);
    ui = {
      root: root,
      panel: root.querySelector('.nb-ask__panel'),
      thread: root.querySelector('.nb-ask__thread'),
      input: root.querySelector('.nb-ask__input'),
      form: root.querySelector('.nb-ask__composer')
    };
    ui.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = ui.input.value.trim();
      if (!v) return;
      ui.input.value = '';
      open({ source: 'composer', noGreet: true }).then(function () { typed(v); });
    });
    ui.thread.addEventListener('click', onThreadClick);
    ui.thread.addEventListener('submit', onHandoffSubmit);
    ui.thread.addEventListener('input', onHandoffInput);
    ui.thread.addEventListener('change', onHandoffInput);
    ui.thread.addEventListener('focusout', onHandoffBlur);
    return ui;
  }

  function syncReset() { if (ui) ui.root.classList.toggle('has-thread', ui.thread.children.length > 0); }
  function scrollDown() {
    if (!ui) return;
    ui.thread.scrollTo ? ui.thread.scrollTo({ top: ui.thread.scrollHeight, behavior: reduced ? 'auto' : 'smooth' }) : (ui.thread.scrollTop = ui.thread.scrollHeight);
  }
  function append(html) {
    var w = document.createElement('div');
    w.innerHTML = html;
    var last = null;
    while (w.firstChild) { last = w.firstChild; ui.thread.appendChild(last); }
    syncReset();
    scrollDown();
    return last;
  }

  /* ------------------------------------------------------------ thread pieces */
  function addChip(text) {
    return append('<div class="nb-ask__chip-row"><span class="nb-ask__chip">' + esc(text) + '</span></div>');
  }
  function addUser(text) {
    return append('<div class="nb-ask__user-row"><span class="nb-ask__user">' + esc(text) + '</span></div>');
  }
  function lastIsBot() {
    var l = ui.thread.lastElementChild;
    return !!(l && l.hasAttribute('data-bot'));
  }
  // html: the bubble's inner HTML. kind: '' | 'recap'
  async function botSay(html, kind) {
    var typing = document.createElement('div');
    typing.className = 'nb-ask__typing';
    typing.setAttribute('aria-hidden', 'true');
    typing.innerHTML = '<i></i><i></i><i></i>';
    var showLabel = !lastIsBot();
    ui.thread.appendChild(typing);
    scrollDown();
    var g0 = gen;
    await wait(600);
    typing.remove();
    if (g0 !== gen) throw new Error(ABORT);
    var m = document.createElement('div');
    m.className = 'nb-ask__bot';
    m.setAttribute('data-bot', '');
    m.innerHTML = (showLabel ? '<span class="nb-ask__who">' + SP + 'nuviebaby</span>' : '') +
      '<div class="nb-ask__bubble' + (kind ? ' nb-ask__bubble--' + kind : '') + '">' + html + '</div>';
    ui.thread.appendChild(m);
    syncReset();
    scrollDown();
    return m;
  }
  function clearReplies() {
    qa('.nb-ask__replies', ui.thread).forEach(function (n) { n.remove(); });
  }
  // ids: node ids. opts: { ghost: 'else'|'none'|null, msg: 'inline'|'row'|null }
  function addReplies(ids, opts) {
    opts = opts || {};
    var pills = ids.filter(function (id) { return D.G[id]; }).map(function (id) {
      return '<button type="button" class="nb-ask__pill" data-id="' + esc(id) + '">' + esc(D.G[id].q) + '</button>';
    });
    if (opts.keep) pills.unshift('<button type="button" class="nb-ask__pill" data-act="keep">' + esc(t('Keep asking')) + '</button>');
    if (opts.msg === 'inline') pills.push('<button type="button" class="nb-ask__pill" data-act="msg">' + esc(t('Message our team')) + '</button>');
    if (opts.ghost === 'else') pills.push('<button type="button" class="nb-ask__pill nb-ask__pill--ghost" data-act="else">' + esc(t('Something else')) + '</button>');
    if (opts.ghost === 'none') pills.push('<button type="button" class="nb-ask__pill nb-ask__pill--ghost" data-act="none">' + esc(t('None of these')) + '</button>');
    // the quiet support hub link sits under the pills and goes with them when the customer picks one
    var hub = (opts.hub && D && D.HUB) ? '<a class="nb-ask__lcard nb-ask__lcard--quiet" href="' + esc(D.HUB.u) + '" target="_blank" rel="noopener" data-card="hub">' +
      '<span class="nb-ask__lcard-title">' + esc(D.HUB.t) + '</span><span class="nb-ask__arrow" aria-hidden="true">↗</span></a>' : '';
    var html = '<div class="nb-ask__replies"' + (opts.start ? ' data-start="1"' : '') + '><div class="nb-ask__replies-row">' + pills.join('') + '</div>' +
      (opts.msg === 'row' ? '<div class="nb-ask__replies-row"><button type="button" class="nb-ask__pill" data-act="msg">' + esc(t('Message our team')) + '</button></div>' : '') +
      hub + '</div>';
    return append(html);
  }

  /* cards */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || CFG.currency || 'SGD';
    var v = cents / 100;
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  }
  function productOnPage(handle) {
    var here = location.pathname.match(/\/products\/([^\/?#]+)/);
    return !!(here && decodeURIComponent(here[1]) === handle);
  }
  // The chat's product card is the site's own product card (nb-c-product-card): the photo fills the top edge to edge,
  // then kicker, title, one line, the live price with the struck compare-at, and the button. The photo, title and line
  // come from the product's entry in the compiled content (products.json); the price and the Save badge come from the
  // live product, never typed. The same Save badge rule as the site: shown only when a compare-at price is higher.
  // A product card the thread already shows is not shown again (cardShown); the answer points back to it instead.
  function cardShown(handle) { return !!(S.cards && S.cards['product:' + handle]); }
  async function productCard(handle) {
    if (productOnPage(handle) || walking || cardShown(handle)) return;
    var reg = D && D.PRODUCTS && D.PRODUCTS[handle];
    if (!reg) return;
    var g = gen;   // the page already shows it
    var p;
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      p = await r.json();
    } catch (e) { return; }
    if (g !== gen) return;
    var file = '/cdn/shop/files/' + encodeURIComponent(reg.image);
    var url = esc(ROOT) + 'products/' + esc(handle);
    var saving = (p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price - p.price : 0;
    var price = p.price != null ? '<span class="nb-ask__price">' + esc(money(p.price)) + '</span>' + (saving ? '<s class="nb-ask__was">' + esc(money(p.compare_at_price)) + '</s>' : '') : '';
    var html = '<div class="nb-ask__pcard" data-card="product" data-handle="' + esc(handle) + '">' +
      '<a class="nb-ask__pcard-media" href="' + url + '" tabindex="-1" aria-hidden="true" style="aspect-ratio:' + reg.w + ' / ' + reg.h + '">' +
        '<img src="' + file + '?width=640" srcset="' + file + '?width=320 320w, ' + file + '?width=640 640w, ' + file + '?width=960 960w" sizes="320px" width="' + reg.w + '" height="' + reg.h + '" alt="" loading="lazy">' +
        (saving ? '<span class="nb-ask__badge">' + esc(t('Save {amount}', { amount: money(saving) })) + '</span>' : '') + '</a>' +
      '<div class="nb-ask__pcard-body">' +
        '<span class="nb-ask__kicker">' + esc(reg.kicker) + '</span>' +
        '<a class="nb-ask__pcard-title" href="' + url + '">' + esc(reg.title) + '</a>' +
        '<p class="nb-ask__pcard-line">' + esc(reg.line) + '</p>' +
        (price ? '<div class="nb-ask__pcard-price">' + price + '</div>' : '') +
        '<a class="nb-ask__pbtn" href="' + url + '">' + esc(t('View product')) + '</a>' +
      '</div></div>';
    S.cards = S.cards || {};
    S.cards['product:' + handle] = 1;
    append(html);
    track('card_view', { kind: 'product', target: '/products/' + handle });
  }
  async function linkCard(kind, item, warrantyMenu, skipIfShown) {
    if (!item) return;
    S.cards = S.cards || {};
    if (skipIfShown && S.cards[item.u]) return;   // a card the thread already shows is not shown twice
    S.cards[item.u] = 1;
    var g = gen;
    var thumb = '';
    // support hub articles have no picture of their own (the page's share image is the shop's), so only other blog posts fetch one
    if (kind === 'article' && /\/blogs\//.test(item.u) && !/\/blogs\/support(\/|$)/.test(item.u)) {
      if (!walking) try {
        var r = await fetch(item.u.replace(/^https?:\/\/[^/]+/, ''));
        if (r.ok) {
          var m = (await r.text()).match(/<meta[^>]+property="og:image"[^>]+content="([^"]+)"/i);
          if (m) thumb = m[1];
        }
      } catch (e) { /* the card renders without a picture */ }
    }
    if (g !== gen) return;
    var lead = thumb ? '<span class="nb-ask__thumb"><img src="' + esc(thumb) + '" alt="" loading="lazy"></span>'
      : '<span class="nb-ask__ic">' + (kind === 'video' ? PLAY_ICON : DOC_ICON) + '</span>';
    var k = esc(t(kind === 'video' ? 'Video guide' : (thumb ? 'From our blog' : (/\/pages\//.test(item.u) ? (warrantyMenu ? 'Warranty' : 'On our site') : 'Support article'))));
    append('<a class="nb-ask__lcard" href="' + esc(item.u) + '" target="_blank" rel="noopener" data-card="' + kind + '">' + lead +
      '<span class="nb-ask__lcard-body"><span class="nb-ask__kicker">' + k + '</span><span class="nb-ask__lcard-title">' + esc(item.t) + '</span></span>' +
      '<span class="nb-ask__arrow" aria-hidden="true">↗</span></a>');
    track('card_view', { kind: kind, target: item.u });
  }

  // A link to a section of the Clean Max page. On that page the card scrolls to the section and closes nothing;
  // anywhere else it opens the page at that section in a new tab, so the conversation stays where it is.
  async function sectionCard(item) {
    if (!item) return;
    S.cards = S.cards || {};
    var key = item.u + '#' + item.a;
    if (S.cards[key]) return;
    S.cards[key] = 1;
    var path = item.u.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '');
    var here = location.pathname.replace(/\/$/, '') === path;
    var attrs = here ? ' href="#' + esc(item.a) + '" data-scroll="' + esc(item.a) + '"' : ' href="' + esc(item.u + '#' + item.a) + '" target="_blank" rel="noopener"';
    append('<a class="nb-ask__lcard" data-card="section"' + attrs + '><span class="nb-ask__ic">' + DOC_ICON + '</span>' +
      '<span class="nb-ask__lcard-body"><span class="nb-ask__kicker">' + esc(t(here ? 'On this page' : 'On our site')) + '</span><span class="nb-ask__lcard-title">' + esc(item.t) + '</span></span>' +
      '<span class="nb-ask__arrow" aria-hidden="true">' + (here ? '↓' : '↗') + '</span></a>');
    track('card_view', { kind: 'section', anchor: item.a, here: here });
  }
  // how far down a bar pinned to the top of the screen reaches (the Clean Max chapter bar), so a section lands under it, not behind it
  function topInset() {
    var h = 0;
    document.elementsFromPoint(24, 4).forEach(function (n) {
      if (n.closest('.nb-ask')) return;
      for (var a = n, i = 0; a && a !== document.body && a !== document.documentElement && i < 14; a = a.parentElement, i++) {
        var cs = getComputedStyle(a);
        if (cs.position === 'fixed' || (cs.position === 'sticky' && cs.top !== 'auto')) { var r = a.getBoundingClientRect(); if (r.height < 220 && r.top <= 4) h = Math.max(h, r.bottom); break; }
      }
    });
    return h;
  }
  // Scroll the page to a section and close nothing. The page below can still be settling (photos, the bar sliding in), so look again and nudge.
  function scrollPageTo(id) {
    var el = document.getElementById(id);
    if (!el) return;
    function gap() { return el.getBoundingClientRect().top - (topInset() + 24); }
    window.scrollBy({ top: gap(), behavior: reduced ? 'auto' : 'smooth' });
    [700, 1500].forEach(function (ms) { setTimeout(function () { var d = gap(); if (Math.abs(d) > 10) window.scrollBy({ top: d, behavior: 'auto' }); }, ms); });
  }

  /* ------------------------------------------------------------ conversation */
  async function visit(id, opt) {
    opt = opt || {};
    var n = D.G[id];
    if (n.goto) {
      // a signpost: its pill was the record, so play the node it points to
      if (!opt.noPath) S.path.push(id);
      var t = resolveGoto(n.goto) || (D.G[ID_WHICH] ? ID_WHICH : '');   // machine not known yet: ask which one first
      if (!t) { await offerFollowUps(S.cur); return; }
      await visit(t, { noPath: true });
      return;
    }
    if (!opt.noPath) S.path.push(id);
    S.cur = id;
    S.seen = S.seen || {};
    S.seen[id] = 1;   // played, even when it was reached through a signpost
    if (n.fk === 'owns-clean') S.machine = 'clean';
    else if (n.fk === 'owns-clean-max') S.machine = 'clean-max';
    if (S.machine) S.pend = 0;   // they own a machine: nothing here is a shopping signal
    if (n.fact) {   // a short phrase for the "So far" line
      S.facts = S.facts.filter(function (f) { return f.k !== id && f.t !== n.fact; });
      S.facts.push({ k: id, t: n.fact });
      if (S.facts.length > 8) S.facts = S.facts.slice(-8);
    }
    if ((n.a || []).length) { S.nAns++; noteShopping(id, n); }
    track('node_view', { node: id, depth: S.path.length });
    var nextIds = (n.next || []).filter(function (x) { return D.G[x]; });
    if (n.product && !nextIds.length && productOnPage(n.product)) n = Object.assign({}, n, { ask: '' });   // no card here, so no question about it
    var bubbles = n.a || [];
    // the card is the answer and the thread already shows it: say where it is rather than "here's" with nothing below
    var regP = n.product && D.PRODUCTS && D.PRODUCTS[n.product];
    if (regP && !nextIds.length && cardShown(n.product) && !productOnPage(n.product)) bubbles = [t('{title} with today\'s price is in the card above.', { title: regP.title })];
    var skipTo = (S.machine && nextIds.length && isPicker(n)) ? machineKid(nextIds, S.machine) : '';   // machine known: never ask again
    var hasCard = !!(n.video || n.article || n.section || (n.product && nextIds.length));
    var askAfter = !!(n.ask && nextIds.length && hasCard && !skipTo);   // question comes after the card
    var askNow = !!(n.ask && !askAfter && !skipTo);
    for (var i = 0; i < bubbles.length; i++) {
      var last = i === bubbles.length - 1;
      await botSay('<p>' + esc(bubbles[i]) + '</p>' + (last && askNow ? '<p class="nb-ask__ask">' + esc(n.ask) + '</p>' : ''));
      if (!last) await wait(350);
    }
    if (!bubbles.length && askNow) await botSay('<p class="nb-ask__ask">' + esc(n.ask) + '</p>');
    if (n.video) await linkCard('video', D.VIDEOS && D.VIDEOS[n.video], false, n.cx === 'video');
    if (n.article) await linkCard('article', D.ARTICLES && D.ARTICLES[n.article], /^clean-owners\.warranty\.menu\./.test(id), n.cx === 'article');
    if (n.blog) await linkCard('article', D.BLOG && D.BLOG[n.blog]);
    if (n.section) await sectionCard(D.SECTIONS && D.SECTIONS[n.section]);
    // a buying signal is waiting and this answer ends the branch: the "So far" card follows, and brings the machine card with it
    var withMoment = momentDue(id, n, nextIds, skipTo);
    if (n.product && !(withMoment && n.product === MACHINE_HANDLE)) await productCard(n.product);
    if (askAfter) await botSay('<p class="nb-ask__ask">' + esc(n.ask) + '</p>');

    if (skipTo) {
      await visit(skipTo, { noPath: true });
    } else if (n.handoff) {
      handoffCard(n.issue || n.q, /^clean-max-pre-sale\./.test(id), '', /^(faults|clean-owners\.warranty)\./.test(id));
    } else if (n.tool === 'warranty-status') {
      await warrantyTool();
    } else if (nextIds.length) {
      await wait(150);
      addReplies(nextIds, id === ID_DOOR ? { start: true, ghost: 'else' } : { ghost: 'else', hub: !!n.hub });
    } else if (withMoment) {
      await moment(id);
    } else {
      await offerFollowUps(id);
    }
  }

  /* ------------------------------------------------------------ read the room */
  // Shopping: no machine yet, and the answer is a Clean Max pre-sale one or a buying one (price, delivery, stock, bundles).
  function isShop(id, n) { return !S.machine && (/^clean-max-pre-sale\./.test(id) || !!(n && n.buy)); }
  // Buying signals: asking about price, delivery, stock, preorder or bundles (strong); telling us they pump or it is their
  // first machine (soft); or a third shopping answer. The first signal calls for the "So far" card. After that, only a new
  // strong signal, at least three answers after the last card, calls for it again.
  function noteShopping(id, n) {
    if (!isShop(id, n)) return;
    S.nShop++;
    if (S.moment < 0) { if (n.buy || S.nShop >= 3) S.pend = 1; }
    else if (n.buy === 2 && S.nAns - S.moment >= 3) S.pend = 1;
  }
  // The card follows the answer that ends a branch. On the Clean Max page itself the machine and its price are already on screen, so nothing is added there.
  function momentDue(id, n, nextIds, skipTo) {
    if (!S.pend || nextIds.length || n.handoff || skipTo || !isShop(id, n)) return false;
    if (productOnPage(MACHINE_HANDLE) || !(D.PRODUCTS && D.PRODUCTS[MACHINE_HANDLE])) { S.pend = 0; S.moment = S.nAns; return false; }
    return true;
  }
  // "two or three short phrases from what they asked", newest last
  function recapText() {
    var seen = {}, f = [];
    for (var i = S.facts.length - 1; i >= 0 && f.length < 3; i--) { if (!seen[S.facts[i].t]) { seen[S.facts[i].t] = 1; f.unshift(S.facts[i].t); } }
    return f.length < 2 ? '' : f.slice(0, -1).join(t(', ')) + t(' and ') + f[f.length - 1];   // one phrase is not a summary, so the line waits for two
  }
  async function moment(fromId) {
    S.pend = 0; S.moment = S.nAns;
    var r = recapText();
    if (r) await botSay('<p>' + esc(t('So far: {list}.', { list: r })) + '</p>', 'recap');
    await productCard(MACHINE_HANDLE);
    track('recap_shown', { answers: S.nAns });
    await botSay('<p class="nb-ask__ask">' + esc(t('Anything else you want to know?')) + '</p>');
    var ids = followUps(fromId);
    markOffered(ids);
    addReplies(ids, { ghost: 'else', start: true, keep: true });
  }

  /* ------------------------------------------------------------ follow-ups */
  // "Anything else you want to know?" offers the next most useful question they have not seen: what goes with the answer
  // they just had first, then the same topic, then the next topic on the page. Never one already answered, never one already
  // offered twice, and always exactly three when three genuinely fit (fewer when they do not; nothing is invented).
  var OWNER_AREA = /^(clean-owners|clean-max-owners|faults)\./;
  var NOFOLLOW = /^(clean-owners|clean-max-owners)\.entry\.|^clean-owners\.door\.(start|have-one|which-)/;   // front-door and picker nodes are not questions to offer
  function topicOf(id) { return id.split('.').slice(0, 2).join('.'); }
  function areaOf(id) { return id.split('.')[0]; }
  // Who is asking: an owner (they said so, or they are in an owner topic), a shopper (a pre-sale answer, or a shopping page), or neither yet
  function context(fromId) {
    var n = (fromId && D.G[fromId]) || {};
    var machine = S.machine || ((fromId && OWNER_AREA.test(fromId) && (n.machine === 'clean' || n.machine === 'clean-max')) ? n.machine : '');
    var md = machine ? 'owner' : (S.nShop > 0 ? 'shop' : ((CFG.page === 'cleanmax' || CFG.page === 'home' || CFG.page === 'bundles') ? 'shop' : 'other'));
    return { md: md, machine: machine };
  }
  function modeKey(md) {
    if (md === 'owner') return 'support';
    if (md === 'shop') return (CFG.page === 'home' || CFG.page === 'bundles') ? CFG.page : 'cleanmax';
    return pageKey(CFG.page);
  }
  function seedList(key) {
    var retired = {};
    (D.RETIRED || []).forEach(function (r) { retired[r] = 1; });
    return ((D.SEEDS || {})[pageKey(key)] || []).slice().sort(function (a, b) { return a[0] - b[0]; }).map(function (x) { return x[1]; }).filter(function (id) { return !retired[id] && D.G[id]; });
  }
  function followUps(fromId, exclude) {
    var cx = context(fromId), md = cx.md, pool = [], explicit = {};
    function add(list, isRel) { (list || []).forEach(function (x) { if (x && pool.indexOf(x) < 0) { pool.push(x); if (isRel) explicit[x] = 1; } }); }
    var n = D.G[fromId] || {};
    var done = {};
    Object.keys(S.seen || {}).concat(S.path).forEach(function (id) { if (D.G[id]) { done[id] = 1; done[normQ(D.G[id].q)] = 1; if ((D.G[id].a || []).length) done['a:' + D.G[id].a.join('|')] = 1; } });   // two nodes can give the same answer: that is answered too
    // 1. what the content says goes with this answer; a child answer takes its parent's list after its own
    add(n.rel, true);
    for (var i = S.path.length - 1; i >= Math.max(0, S.run); i--) { var pn = D.G[S.path[i]]; if (pn && S.path[i] !== fromId) add(pn.rel, true); }
    // 2. the same topic, then the same area (the other questions about the same thing)
    if (fromId) {
      var topic = topicOf(fromId), area = areaOf(fromId);
      var ids = Object.keys(D.G);
      var standalone = function (id) { return TOP[id] || QPILL[id]; };
      add(ids.filter(function (id) { return topicOf(id) === topic && standalone(id); }));
      add(ids.filter(function (id) { return areaOf(id) === area && standalone(id); }));
    }
    // 3. the next topic on this page, after this one, then the rest
    var seeds = seedList(modeKey(md));
    var pos = -1;
    if (fromId) { var tp = topicOf(fromId); for (var k = 0; k < seeds.length; k++) { if (topicOf(seeds[k]) === tp) { pos = k; break; } } }
    add(seeds.slice(pos + 1));
    add(seeds.slice(0, pos + 1));
    // 4. a last stretch from the mode's own questions, so a short page still fills the row
    if (md === 'shop') add(seedList('cleanmax'));
    else add(seedList('support'));
    var picked = [];
    for (var j = 0; j < pool.length && picked.length < 3; j++) {
      var id2 = pool[j], g = D.G[id2];
      if (!g || g.handoff || NOFOLLOW.test(id2)) continue;
      if (g.goto) { var tgt = resolveGoto(g.goto); if (!tgt || !D.G[tgt] || done[tgt]) continue; }   // a signpost counts as the node it opens
      if (id2 === S.cur || id2 === fromId || done[id2] || done[normQ(g.q)] || ((g.a || []).length && done['a:' + g.a.join('|')])) continue;
      if ((S.offered[id2] || 0) >= 2 || (S.offered['q:' + normQ(g.q)] || 0) >= 2) continue;
      if (exclude && exclude.indexOf(id2) >= 0) continue;
      if (g.machine && cx.machine && g.machine !== cx.machine) continue;
      if (md === 'shop' && g.machine === 'clean') continue;
      if (md !== 'shop' && /^clean-max-pre-sale\./.test(id2)) continue;
      if (md === 'shop' && OWNER_AREA.test(id2)) continue;
      if (!explicit[id2] && !TOP[id2] && !QPILL[id2] && !g.goto) continue;
      if (picked.some(function (x) { return normQ(D.G[x].q) === normQ(g.q); })) continue;
      picked.push(id2);
    }
    if (picked.length < 3 && exclude && exclude.length) {   // not enough that is new since the last row: top up with what fits from before
      followUps(fromId).forEach(function (x) { if (picked.length < 3 && picked.indexOf(x) < 0) picked.push(x); });
    }
    return picked;
  }
  function markOffered(ids) {
    ids.forEach(function (id) { S.offered[id] = (S.offered[id] || 0) + 1; var qk = 'q:' + normQ(D.G[id].q); S.offered[qk] = (S.offered[qk] || 0) + 1; });   // by id and by wording: two nodes can share a pill
    S.lastRow = ids.slice();
  }
  async function offerFollowUps(fromId, exclude) {
    var ids = followUps(fromId, exclude);
    await botSay('<p class="nb-ask__ask">' + esc(t('Anything else you want to know?')) + '</p>');
    markOffered(ids);
    addReplies(ids, { ghost: 'else', start: true });
  }
  async function keepAsking() {
    track('keep_asking', {});
    busy = true;
    var g = gen;
    try { await offerFollowUps(S.cur, S.lastRow.slice()); }
    catch (err) { if (!isAbort(err)) console.error('[nb-ask] keep asking', err); }
    finally { if (g === gen) { busy = false; save(); } }
  }
  async function go(id, o) {
    o = o || {};
    if (busy || !D || !D.G[id]) return;
    S.auto = '';
    if (!o.chip && S.path.length && S.path[S.path.length - 1] === id && ui.thread.children.length) { scrollDown(); return; }   // already the last exchange: open and show it, append nothing
    busy = true;
    var g = gen;
    try {
      if (!o.chip) clearReplies();   // a new question starts: the previous run's unchosen pills go
      if (o.start || o.source === 'seed' || o.source === 'event' || o.source === 'page') S.run = S.path.length;   // a new topic starts a new run
      if (!o.chip) addChip(D.G[id].q);
      track('pill_tap', { node: id, source: o.source || '', path: S.path.join('>') });
      await visit(id);
      await ensureOptions(id);
    } catch (err) { if (!isAbort(err)) { console.error('[nb-ask] node ' + id, err); try { await ensureOptions(id); } catch (e2) { /* abort */ } } }
    finally { if (g === gen) { busy = false; save(); } }
  }
  function isAbort(err) { return !!(err && err.message === ABORT); }
  // No dead ends: every turn finishes with something to tap. If a node left nothing, say so in the
  // console (with the node id) and offer the closing question with two seeds and Something else.
  async function ensureOptions(id) {
    if (!ui) return;
    var l = ui.thread.lastElementChild;
    if (l && l.querySelector && l.querySelector('[data-nb-tool]')) return;   // a tool form is the next step
    if (l && ((l.classList.contains('nb-ask__replies') && l.querySelector('button')) ||
              (l.classList.contains('nb-ask__handoff') && !l.classList.contains('is-sent')))) return;
    console.warn('[nb-ask] turn ended with no options at node ' + id);
    await offerFollowUps(S.cur);
  }
  // Start over: wipe the thread and the machine, play the opening question
  function reset() {
    if (!ui || !D) return Promise.resolve();
    gen++;
    S = fresh();
    try { sessionStorage.removeItem(KEY); } catch (e) { /* storage blocked */ }
    ui.thread.innerHTML = '';
    syncReset();
    track('start_over', {});
    busy = true;
    var g = gen;
    return greet().then(function () { return ensureOptions('greet'); }).catch(function (err) { if (!isAbort(err)) console.error('[nb-ask] start over', err); })
      .then(function () { if (g === gen) { busy = false; save(); } });
  }
  async function greet() {
    S.machine = '';
    if (D.G[ID_DOOR]) {   // the front door: do they already have a machine?
      S.run = S.path.length;
      await visit(ID_DOOR);
      return;
    }
    var p = CFG.page;
    var text = p === 'cleanmax' ? 'What would you like to know about Clean Max?' :
      (p === 'support' || p === 'faq') ? 'What do you need help with?' : 'What would you like to know?';
    await botSay('<p>' + esc(t(text)) + '</p>');
    addReplies(pageSeeds(5), { start: true });
  }
  async function somethingElse() {
    busy = true;
    try {
      await botSay('<p>' + esc(t('Type your question in your own words.')) + '</p>');
      var more = followUps(S.cur);
      markOffered(more);
      addReplies(more, { msg: 'inline', start: true, hub: true });
      if (!isPhone() && curInput()) { try { curInput().focus({ preventScroll: true }); } catch (e) { curInput().focus(); } }
    } finally { busy = false; save(); }
  }
  async function typed(text) {
    if (busy || !D) return;
    S.auto = '';
    busy = true;
    var g = gen;
    try {
      clearReplies();
      addUser(text);
      S.typed = text;
      S.run = S.path.length;
      var hits = route(text);
      var topic = topicRoute(text);
      if (topic) hits = [[topic, 99, 9, 1]];
      var seenQ = {};
      hits = hits.filter(function (h) { var k = D.G[h[0]].q; if (seenQ[k]) return false; seenQ[k] = 1; return true; });
      track(hits.length ? 'typed_matched' : 'typed_unmatched', { length: text.length, text: text, node: hits.length ? hits[0][0] : '' });
      if (hits.length && (hits.length === 1 || hits[0][1] >= hits[1][1] * 1.25)) {
        await botSay('<p>' + esc(t('Here\'s what we have on that.')) + '</p>');
        await visit(hits[0][0]);
      } else if (hits.length) {
        await botSay('<p>' + esc(t('Here\'s what we have on that.')) + '</p>');
        addReplies(hits.map(function (h) { return h[0]; }), { ghost: 'none', msg: 'row', start: true });
      } else {
        await botSay('<p>' + esc(t('We don\'t have an answer for that one.')) + '</p><p class="nb-ask__ask">' + esc(t('Is one of these closer?')) + '</p>');
        var closer = followUps(S.cur);
        markOffered(closer);
        addReplies(closer, { ghost: 'none', msg: 'row', start: true });
      }
      await ensureOptions('typed');
    } catch (err) { if (!isAbort(err)) console.error('[nb-ask] typed', err); }
    finally { if (g === gen) { busy = false; save(); } }
  }

  function onThreadClick(e) {
    var cc = e.target.closest('[data-card]');
    if (cc && cc.getAttribute('data-card') !== 'hub' && !cc.hasAttribute('data-scroll')) {
      var ca = cc.matches('a[href]') ? cc : cc.querySelector('a[href]');
      if (e.target.closest('a[href]')) track('card_click', { kind: cc.getAttribute('data-card'), target: cc.getAttribute('data-card') === 'product' ? '/products/' + cc.getAttribute('data-handle') : (ca ? ca.getAttribute('href') : '') });
    }
    if (e.target.closest('[data-card="hub"]')) { track('hub_click', { from: S.cur }); return; }
    var sc = e.target.closest('[data-scroll]');
    if (sc) { e.preventDefault(); track('section_scroll', { to: sc.getAttribute('data-scroll') }); scrollPageTo(sc.getAttribute('data-scroll')); return; }
    var b = e.target.closest('.nb-ask__pill');
    if (!b || busy || !D) return;
    S.auto = '';
    var text = b.textContent;
    var id = b.getAttribute('data-id');
    var act = b.getAttribute('data-act');
    var start = !!b.closest('[data-start]');
    var cur = D.G[S.cur];
    if (id && D.G[id] && D.G[id].machine && cur && isPicker(cur)) S.machine = D.G[id].machine;   // they just told us which machine
    clearReplies();           // the tapped pill becomes the record, the others go
    addChip(text);
    if (id) go(id, { chip: true, source: 'reply', start: start });
    else if (act === 'msg') { handoffCard('General question', false, S.typed || ''); save(); }
    else if (act === 'keep') keepAsking();
    else somethingElse();
  }

  /* ------------------------------------------------------------ warranty status tool */
  // The module is loaded the first time a tool node plays. It reports only the outcome
  // (active, expired, pending, not_found, error); the serial and email never reach tracking.
  var warrantyLoad = null;
  function loadWarranty() {
    if (window.nbAskWarranty) return Promise.resolve(true);
    if (!warrantyLoad) warrantyLoad = new Promise(function (res) {
      if (!CFG.warrantyUrl) { res(false); return; }
      var sc = document.createElement('script');
      sc.src = CFG.warrantyUrl; sc.async = true;
      sc.onload = function () { res(!!window.nbAskWarranty); };
      sc.onerror = function () { warrantyLoad = null; res(false); };
      document.head.appendChild(sc);
    });
    return warrantyLoad;
  }
  async function warrantyTool() {
    var ok = await loadWarranty();
    if (!ok) { handoffCard('Warranty status', false, '', true); return; }   // module unreachable: the team form instead
    var m = document.createElement('div');
    m.className = 'nb-ask__bot';
    m.setAttribute('data-bot', '');
    m.innerHTML = '<div class="nb-ask__bubble"><div data-nb-tool="warranty-status"></div></div>';
    ui.thread.appendChild(m);
    syncReset(); scrollDown();
    window.nbAskWarranty.render(m.querySelector('[data-nb-tool]'), {
      onTeam: function () { handoffCard('Warranty status', false, '', true); },
      onResult: function (result) { track('tool_result', { tool: 'warranty-status', result: result }); }
    });
  }

  /* ------------------------------------------------------------ handoff */
  function handoffCard(issue, preSale, prefill, faults) {
    var channels = (D && D.CHANNELS) || ['whatsapp', 'email'];
    var btns = '';
    // both send buttons stay disabled until Full name and Email are valid (syncHandoff)
    if (channels.indexOf('whatsapp') >= 0) btns += '<button type="submit" class="nb-ask__btn" data-channel="whatsapp" disabled>' + esc(t('WhatsApp our team')) + '</button>';
    if (channels.indexOf('email') >= 0) btns += '<button type="submit" class="nb-ask__btn nb-ask__btn--ghost" data-channel="email" disabled>' + esc(t('Email our team')) + '</button>';
    var uid = 'h' + Date.now().toString(36);
    append('<form class="nb-ask__handoff" data-issue="' + esc(issue) + '" novalidate>' +
      '<span class="nb-ask__handoff-title">' + esc(t('Message our team')) + '</span>' +
      '<p class="nb-ask__handoff-intro">' + esc(t('Complete your details below and we\'ll hand you over to our team.')) + '</p>' +
      '<label class="nb-ask__field"><span>' + esc(t('Full name')) + '</span><input name="name" type="text" required autocomplete="name" placeholder="' + esc(t('First and last name')) + '" aria-describedby="' + uid + 'nh">' +
        '<span class="nb-ask__hint" id="' + uid + 'nh" data-hint="name" hidden>' + esc(t('Add your first and last name')) + '</span></label>' +
      '<label class="nb-ask__field"><span>' + esc(t('Email')) + '</span><input name="email" type="email" required autocomplete="email" inputmode="email" placeholder="' + esc(t('The one you ordered with')) + '" aria-describedby="' + uid + 'eh">' +
        '<span class="nb-ask__hint" id="' + uid + 'eh" data-hint="email" hidden>' + esc(t('Check your email address')) + '</span></label>' +
      (preSale ? '' : '<label class="nb-ask__field"><span>' + esc(t('Order number (optional)')) + '</span><input name="order" type="text" autocomplete="off"></label>') +
      '<label class="nb-ask__field"><span>' + esc(t('Anything else to add?')) + '</span><textarea name="note" rows="3" placeholder="' + esc(t(issue === 'Update warranty details' ? 'Your serial number and what needs changing' : faults ? 'Your serial number, and anything that helps us look into it' : 'Details that help us look into it')) + '">' + esc(prefill || '') + '</textarea></label>' +
      '<div class="nb-ask__handoff-actions">' + btns + '</div></form>');
    track('handoff_open', { issue: issue });
  }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  // first and last name; a Chinese name is often written without a space, so two characters do there
  function nameOk(v) { v = String(v || '').trim(); return /[\u3400-\u9fff]/.test(v) ? v.replace(/\s+/g, '').length >= 2 : v.split(/\s+/).filter(Boolean).length >= 2; }
  function emailOk(v) { return EMAIL_RE.test(String(v || '').trim()); }
  function fieldOk(input) { return input.name === 'name' ? nameOk(input.value) : emailOk(input.value); }
  // buttons follow the two required fields
  function syncHandoff(form) {
    var ok = nameOk(form.elements.name.value) && emailOk(form.elements.email.value);
    qa('[data-channel]', form).forEach(function (b) { b.disabled = !ok; });
    return ok;
  }
  // the short hint under a field: shown on blur when invalid, gone as soon as it is valid
  function showHint(input, show) {
    var h = input.parentNode.querySelector('[data-hint]');
    if (h) h.hidden = !show;
    input.classList.toggle('is-invalid', show);
    if (show) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  }
  function onHandoffInput(e) {
    var input = e.target;
    var form = input.closest && input.closest('.nb-ask__handoff:not([data-nb-warranty-form])');
    if (!form || form.classList.contains('is-sent')) return;
    if (input.name === 'name' || input.name === 'email') {
      var h = input.parentNode.querySelector('[data-hint]');
      if (h && !h.hidden) showHint(input, !fieldOk(input));   // already flagged: clear it the moment it is right
    }
    syncHandoff(form);
  }
  function onHandoffBlur(e) {
    var input = e.target;
    var form = input.closest && input.closest('.nb-ask__handoff:not([data-nb-warranty-form])');
    if (!form || form.classList.contains('is-sent')) return;
    if (input.name === 'name' || input.name === 'email') showHint(input, !fieldOk(input));
    syncHandoff(form);
  }
  // a form restored from the saved thread has lost what was typed: start it disabled and unflagged
  function resetHandoffs() {
    qa('.nb-ask__handoff:not([data-nb-warranty-form]):not(.is-sent)', ui.thread).forEach(function (f) {
      qa('[data-hint]', f).forEach(function (h) { h.hidden = true; });
      qa('input', f).forEach(function (i) { i.classList.remove('is-invalid'); i.removeAttribute('aria-invalid'); });
      syncHandoff(f);
    });
  }
  function buildMessage(form) {
    var issue = form.getAttribute('data-issue');
    var name = form.elements.name.value.trim().replace(/\s+/g, ' ');
    var email = form.elements.email.value.trim();
    var order = form.elements.order ? form.elements.order.value.trim() : '';
    var note = form.elements.note.value.trim();
    // the message is for our team, so what they picked is listed in English (qe) even on a translated page
    var picked = S.path.slice(S.run || 0).map(function (id) { return D.G[id] ? (D.G[id].qe || D.G[id].q) : ''; }).filter(Boolean).join(' > ');
    var lines = ['Ask nuviebaby: ' + issue, '', 'Name: ' + name, 'Email: ' + email];
    if (LANG) lines.push('Language: ' + (LANG === 'ms' ? 'Malay' : 'Chinese'));
    if (order) lines.push('Order number: ' + order);
    if (note) lines.push('Note: ' + note);
    lines.push('', 'What I picked: ' + picked);
    return { issue: issue, text: lines.join('\n') };
  }
  function onHandoffClick(e) {
    var b = e.target.closest('.nb-ask__handoff [data-channel]');
    if (b) b.form.setAttribute('data-chosen', b.getAttribute('data-channel'));
  }
  function onHandoffSubmit(e) {
    var form = e.target.closest('.nb-ask__handoff:not([data-nb-warranty-form])');
    if (!form) return;
    e.preventDefault();
    var channel = (e.submitter && e.submitter.getAttribute('data-channel')) || form.getAttribute('data-chosen') || 'whatsapp';
    var nameEl = form.elements.name, mailEl = form.elements.email;
    var nOk = nameOk(nameEl.value), eOk = emailOk(mailEl.value);
    if (!nOk || !eOk) {   // the buttons are disabled until both are valid; this guards Enter and autofill
      showHint(nameEl, !nOk);
      showHint(mailEl, !eOk);
      (nOk ? mailEl : nameEl).focus();
      syncHandoff(form);
      return;
    }
    var msg = buildMessage(form);
    var url;
    if (channel === 'email') {
      url = 'mailto:' + SUPPORT_EMAIL + '?subject=' + encodeURIComponent('Ask nuviebaby: ' + msg.issue) + '&body=' + encodeURIComponent(msg.text.replace(/\n/g, '\r\n'));
      var a = document.createElement('a');   // an anchor click opens the mail app without leaving the page
      a.href = url;
      a.className = 'nb-ask__mailto';
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      url = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg.text);
      window.open(url, '_blank', 'noopener');
    }
    track('handoff_send', { channel: channel, issue: msg.issue });
    // freeze the card as the record of what was sent
    qa('input,textarea,button', form).forEach(function (el) { el.disabled = true; });
    form.classList.add('is-sent');
    afterHandoff(channel);
  }
  async function afterHandoff(channel) {
    busy = true;
    try {
      await botSay('<p>' + esc(t(channel === 'email'
        ? 'Your email is ready. Press send, and add photos or video if they help.'
        : 'Your message is ready in WhatsApp. Press send, and add photos or video if they help.')) + '</p>');
      await offerFollowUps(S.cur);
    } finally { busy = false; save(); }
  }

  /* ------------------------------------------------------------ open / close */
  function setOpen(on) {
    if (!ui) return;
    ui.root.classList.toggle('is-open', on);
    ui.panel.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('nb-ask-lock', on);
    document.body.classList.toggle('nb-ask-open', on);
  }
  // o: { nodeId, question, source, noGreet }
  function open(o) {
    o = o || {};
    var wasOpen = !!(ui && ui.root.classList.contains('is-open'));
    returnFocus = returnFocus || document.activeElement;
    buildUI();
    restore();
    clearTimeout(ui.__back);
    place('panel');
    // two frames so the slide-in transition runs on the very first open
    requestAnimationFrame(function () { requestAnimationFrame(function () { setOpen(true); try { ui.panel.focus({ preventScroll: true }); } catch (e) {} }); });
    if (!wasOpen) track('widget_open', { source: o.source || '' });   // typing into a panel that is already open is not a new open
    return loadContent().then(function () {
      scrollDown();
      var id = o.nodeId || (o.question ? resolveQuestion(o.question) : null);
      if (S.auto) {   // the page seeded the inline answer and nobody has touched it
        if (!id && !o.noGreet) { S = fresh(); ui.thread.innerHTML = ''; syncReset(); } else S.auto = '';
      }
      if (id && D.G[id]) return go(id, { source: o.source || 'page' });
      if (!ui.thread.children.length && !o.noGreet) { busy = true; var g = gen; return greet().then(function () { return ensureOptions('greet'); }).catch(function (err) { if (!isAbort(err)) console.error('[nb-ask] greet', err); }).then(function () { if (g === gen) { busy = false; save(); } }); }
    }).catch(function () {
      if (!ui.thread.children.length) {
        append('<div class="nb-ask__bot" data-bot=""><div class="nb-ask__bubble"><p>' + esc(t('We couldn\'t load Ask nuviebaby just now. Please try again in a moment.')) + '</p></div></div>');
      }
    });
  }
  function close() {
    if (!ui || !ui.root.classList.contains('is-open')) return;
    setOpen(false);
    track('widget_close', { depth: S.path.length });
    save();
    if (inl) { clearTimeout(ui.__back); ui.__back = setTimeout(function () { if (!ui.root.classList.contains('is-open')) place('inline'); }, 320); }
    if (returnFocus && returnFocus.focus) { try { returnFocus.focus({ preventScroll: true }); } catch (e) {} }
    returnFocus = null;
  }

  /* ------------------------------------------------------------ wiring */
  // The floating launcher carries a teaser question as its second line, but opening it from the
  // launcher is "open Ask nuviebaby", so it starts at the front door like any question-less opener.
  // A launcher that shows a specific question opens that question's node; one with no question text opens the front door.
  var fromLauncher = false, launcherQ = '';
  document.addEventListener('click', function (e) {
    var L = e.target.closest && e.target.closest('[data-nb-ask-launcher]');
    if (L) {
      fromLauncher = true;
      var qEl = L.hasAttribute('data-nb-ask-question') ? L : L.querySelector('[data-nb-ask-question]');
      launcherQ = ((qEl && qEl.getAttribute('data-nb-ask-question')) || '').trim();
      setTimeout(function () { fromLauncher = false; }, 0);
    }
  }, true);
  // Pages on the legacy layout (the Clean product page) do not load nb-ui.js, which is what turns a
  // [data-nb-ask] click into the nb:ask event. Do it here, only when nb-ui.js is absent.
  document.addEventListener('click', function (e) {
    if (document.querySelector('script[src*="nb-ui.js"]')) return;
    var t = e.target.closest && e.target.closest('[data-nb-ask]');
    if (!t || e.defaultPrevented) return;
    e.preventDefault();
    var qEl = t.hasAttribute('data-nb-ask-question') ? t : t.querySelector('[data-nb-ask-question]');
    document.dispatchEvent(new CustomEvent('nb:ask', { detail: { question: qEl ? (qEl.getAttribute('data-nb-ask-question') || '') : '' }, cancelable: true, bubbles: true }));
  });
  document.addEventListener('nb:ask', function (e) {
    e.preventDefault();
    var q = fromLauncher ? launcherQ : (e.detail && e.detail.question);
    open({ question: q || '', source: fromLauncher ? 'launcher' : 'event' });
  });
  // Clean Max PDP buy-box teaser pills used to open separate side pop-ups (nb-c-question-panel).
  // They now open the Ask panel on the matching node instead. Capture phase, so the old
  // sheet/drawer triggers never run. To remove the old panels entirely, drop the
  // nb-c-question-panel render from sections/nb-cmax-close.liquid and this block.
  var QKEY_TEXT = { bottles: 'Will my bottles fit?', cycle: 'How long does a cycle take?', noisy: 'Is it noisy?' };
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nb-qpanel-switch], [data-nb-question]');
    if (!t) return;
    var key = t.getAttribute('data-nb-qpanel-switch') || t.getAttribute('data-nb-question');
    var text = QKEY_TEXT[key] || (t.textContent || '').replace(/[✦\s]+/g, ' ').trim();
    if (!text) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open({ question: text, source: 'pdp-pill' });
  }, true);
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-nb-ask-node]');
    if (s) { e.preventDefault(); open({ nodeId: s.getAttribute('data-nb-ask-node'), source: 'seed' }); return; }
    if (e.target.closest('[data-nb-ask-reset]')) { reset(); return; }
    if (e.target.closest('[data-nb-ask-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab' && ui && ui.root.classList.contains('is-open')) {
      var f = qa('button:not([disabled]), input:not([disabled]), textarea:not([disabled]), a[href]', ui.panel);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === ui.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  function fadeRows() {
    qa('.nb-cmax-buy__pills', document).forEach(function (r) {
      function upd() { r.classList.toggle('is-at-end', r.scrollLeft + r.clientWidth >= r.scrollWidth - 2); }
      if (!r.__nbFade) { r.__nbFade = true; r.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); }
      upd();
    });
  }
  /* ------------------------------------------------------------ teaser pills under the PDP title */
  // One line of seed pills that drifts sideways in a seamless loop (about 32s a lap). Pauses on
  // hover, touch and focus; swipeable at any time; with reduced motion it stays a still, swipeable row.
  var LOOP_SECONDS = 32;
  function teaserPill(id, q, hidden) {
    return '<button type="button" class="nb-ask-seed" data-nb-ask-node="' + esc(id) + '"' + (hidden ? ' tabindex="-1"' : '') + '>' + SP + '<span>' + esc(q) + '</span></button>';
  }
  function fillTeasers(root) {
    qa('[data-nb-ask-teaser]', root).forEach(function (el) {
      if (el.__nbT) return;
      el.__nbT = true;
      var key = el.getAttribute('data-nb-ask-teaser');
      loadSeeds().then(function (src) {
        var ids = seedIds(key, src).filter(function (id) { return src.Q ? !!src.Q[id] : !!(D && D.G[id]); }).slice(0, 8);
        if (!ids.length) { el.hidden = true; return; }
        var q = function (id) { return src.Q ? src.Q[id] : D.G[id].q; };
        el.innerHTML = '<div class="nb-ask-teaser__vp" role="group" aria-label="' + esc(t('Questions you can ask')) + '"><div class="nb-ask-teaser__track">' +
          '<div class="nb-ask-teaser__set">' + ids.map(function (id) { return teaserPill(id, q(id)); }).join('') + '</div></div></div>';
        var vp = el.firstChild, track = vp.firstChild, set = track.firstChild;
        el.classList.add('is-ready');
        if (reduced) { stillTeaser(vp); return; }
        loopTeaser(vp, track, set, ids.map(function (id) { return teaserPill(id, q(id), true); }).join(''));
      });
    });
  }
  function stillTeaser(vp) {
    vp.classList.add('is-still');
    function upd() {
      vp.classList.toggle('is-at-start', vp.scrollLeft <= 2);
      vp.classList.toggle('is-at-end', vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 2);
    }
    vp.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  function loopTeaser(vp, track, set, pillsHtml) {
    var W = 0, pos = 0, last = 0, lastSet = 0, hold = 0, paused = false, onScreen = true, copies = 0, running = false;
    function build() {
      var w = set.offsetWidth;
      if (!w) return;
      var need = Math.max(3, Math.ceil(vp.clientWidth / w) + 2);
      if (need !== copies) {
        while (track.children.length > 1) track.removeChild(track.lastChild);
        for (var i = 1; i < need; i++) {
          var c = document.createElement('div');
          c.className = 'nb-ask-teaser__set';
          c.setAttribute('aria-hidden', 'true');
          c.innerHTML = pillsHtml;
          track.appendChild(c);
        }
        copies = need;
      }
      var first = !W;
      W = w;
      if (first || pos < W || pos >= 2 * W) { pos = W + (pos % W || 0); vp.scrollLeft = pos; lastSet = vp.scrollLeft; }
    }
    // Frames run only while the row is on screen and the tab is visible; reading and setting
    // scrollLeft every frame otherwise kept the main thread busy for the whole visit.
    function kick() { if (!running && onScreen && !document.hidden) { running = true; last = 0; requestAnimationFrame(frame); } }
    function frame(t) {
      if (!onScreen || document.hidden) { running = false; return; }
      requestAnimationFrame(frame);
      var dt = last ? Math.min(t - last, 64) : 16;
      last = t;
      if (!W) { build(); return; }
      if (Math.abs(vp.scrollLeft - lastSet) > 1.5) { pos = vp.scrollLeft; lastSet = pos; hold = t + 1800; }   // they moved it
      var moving = onScreen && !paused && t >= hold && !document.hidden;
      if (moving) pos += W / (LOOP_SECONDS * 1000) * dt;
      var wrapped = false;
      if (pos < W) { pos += W; wrapped = true; } else if (pos >= 2 * W) { pos -= W; wrapped = true; }
      if (moving || wrapped) { vp.scrollLeft = pos; lastSet = vp.scrollLeft; }
    }
    build();
    kick();
    document.addEventListener('visibilitychange', kick);
    if (window.ResizeObserver) new ResizeObserver(build).observe(vp);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
    if (window.IntersectionObserver) new IntersectionObserver(function (en) { onScreen = en[en.length - 1].isIntersecting; kick(); }).observe(vp);
    vp.addEventListener('mouseenter', function () { paused = true; });
    vp.addEventListener('mouseleave', function () { paused = false; });
    vp.addEventListener('focusin', function () { paused = true; });
    vp.addEventListener('focusout', function () { paused = false; });
    vp.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (n) { vp.addEventListener(n, function () { paused = false; hold = performance.now() + 2200; }, { passive: true }); });
  }

  /* ------------------------------------------------------------ inline Questions panel */
  // Shows the page's first seeded answer and the next seeds as pills. Everything plays inside the
  // panel; the thread is the same one the slide-out uses.
  function inlineOk(id) {
    var n = D.G[id];
    return !!(n && n.a && n.a.length && !n.goto && !n.handoff && !isPicker(n));
  }
  function seedInline() {
    var ids = pageSeeds(undefined, inl.key);
    var first = ids.filter(inlineOk)[0];
    if (!first) return;
    gen++;
    S = fresh();
    S.auto = inl.key;
    S.path.push(first);
    S.cur = first;
    ui.thread.innerHTML = '';
    var n = D.G[first];
    addChip(n.q);
    append(n.a.map(function (t) { return '<div class="nb-ask__bot" data-bot=""><div class="nb-ask__bubble"><p>' + esc(t) + '</p></div></div>'; }).join(''));
    addReplies(ids.filter(function (x) { return x !== first; }).slice(0, 3), { start: true });
    var th = ui.thread;
    th.scrollTop = 0;
    setTimeout(function () { th.scrollTo ? th.scrollTo({ top: 0, behavior: 'auto' }) : (th.scrollTop = 0); }, 80);
    save();
  }
  function attachInline(host) {
    if (inl || !host) return;
    inl = {
      host: host,
      body: host.querySelector('[data-nb-ask-inline-body]'),
      form: host.querySelector('[data-nb-ask-inline-form]'),
      input: host.querySelector('[data-nb-ask-inline-input]'),
      key: host.getAttribute('data-nb-ask-inline') || CFG.page || ''
    };
    buildUI();
    restore();
    if (!ui.root.classList.contains('is-open')) place('inline');
    host.classList.add('is-live');
    inl.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = inl.input.value.trim();
      if (!v) return;
      inl.input.value = '';
      loadContent().then(function () { if (!ui.root.classList.contains('is-open')) typed(v); });
    });
    loadContent().then(function () {
      if (!ui.thread.children.length || (S.auto && S.auto !== inl.key)) seedInline();
      scrollDown();
    }).catch(function () {
      if (!ui.thread.children.length) append('<div class="nb-ask__bot" data-bot=""><div class="nb-ask__bubble"><p>' + esc(t('We couldn\'t load Ask nuviebaby just now. Please try again in a moment.')) + '</p></div></div>');
    });
  }
  function initInline(root) {
    var host = qa('[data-nb-ask-inline]', root)[0];
    if (!host || inl) return;
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); attachInline(host); }
      }, { rootMargin: '700px 0px' });
      io.observe(host);
    } else attachInline(host);
  }
  function fillLauncher() {
    var L = qa('[data-nb-ask-launcher-product]')[0];
    if (!L || !CFG.page) return;
    loadSeeds().then(function (src) {
      var id = seedIds(CFG.page, src).filter(function (x) { return src.Q ? !!src.Q[x] : !!(D && D.G[x]); })[0];
      var t = id ? (src.Q ? src.Q[id] : D.G[id].q) : '';
      if (!t) return;
      var s = L.querySelector('.nb-c-ask-launcher__q');
      if (s) { s.textContent = t; s.hidden = false; }
      L.setAttribute('data-nb-ask-question', t);
    });
  }
  // On /ms/ and /zh/ a page pill can still carry its English setting text. The English stays as the
  // attribute (it routes through qe); only the words the shopper sees change. A label that is not the
  // question itself (a button reading "Ask nuviebaby") is left alone, and so is any pill with no match.
  function translatePills(root) {
    if (!LANG) return;
    var els = qa('[data-nb-ask-question]', root).filter(function (el) {
      var k = normQ(el.getAttribute('data-nb-ask-question') || '');
      return k && normQ(el.textContent || '') === k;
    });
    if (!els.length) return;
    loadContent().then(function () {
      els.forEach(function (el) {
        var k = normQ(el.getAttribute('data-nb-ask-question'));
        var id = Object.keys(D.G).filter(function (x) { return !D.G[x].goto && D.G[x].qe && normQ(D.G[x].qe) === k; })[0];
        if (!id || !D.G[id].q) return;
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { if (normQ(n.nodeValue) === k) { n.nodeValue = n.nodeValue.replace(/\S[\s\S]*\S|\S/, D.G[id].q); break; } }
      });
    }).catch(function () {});
  }
  function init() { fillSeeds(document); fadeRows(); fillTeasers(document); fillLauncher(); translatePills(document); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { fillSeeds(e.target || document); fillTeasers(e.target || document); translatePills(e.target || document); });
  if (document.readyState !== 'loading') init();

  window.nbAsk = {
    __ready: true,
    open: function (o) { return open(o || {}); },
    close: close,
    // answers "which node would this text open?" without opening the panel; used by the checks
    resolve: function (text) { return loadContent().then(function () { var id = resolveQuestion(text); return { pill: id ? D.G[id].q : null, typed: route(text).map(function (h) { return D.G[h[0]].q + ' (' + h[1].toFixed(1) + ')'; }) }; }); },
    reset: reset,
    // debug helpers for the walker (dev only, harmless on live): nodes, per-node state, typed and tap
    __ids: function () { return loadContent().then(function () { return Object.keys(D.G); }); },
    __q: function (id) { return D && D.G[id] ? D.G[id].q : ''; },
    __S: function () { return JSON.parse(JSON.stringify(S)); },
    __rowFor: function (id) { return followUps(id).map(function (x) { return D.G[x].q; }); },
    __setup: function (machine) {
      return open({ noGreet: true }).then(function () {
        walking = true; reduced = true; gen++; busy = false;
        S = fresh(); S.machine = machine || ''; ui.thread.innerHTML = ''; syncReset();
      });
    },
    __go: function (id) { return go(id, { source: 'seed', start: true }); },
    __typed: function (text) { return typed(text); },
    __tap: function (n) {
      var b = qa('.nb-ask__replies .nb-ask__pill', ui.thread)[n || 0];
      if (!b) return Promise.resolve(false);
      b.click();
      return new Promise(function (res) { (function poll() { if (!busy) res(true); else setTimeout(poll, 5); })(); });
    },
    __state: function () {
      var l = ui.thread.lastElementChild;
      return {
        pills: qa('.nb-ask__replies .nb-ask__pill', ui.thread).map(function (b) { return b.textContent; }),
        handoff: !!(l && (l.classList.contains('nb-ask__handoff') || (l.querySelector && l.querySelector('[data-nb-tool]')))),
        text: qa('.nb-ask__bubble', ui.thread).map(function (b) { return b.textContent; }),
        busy: busy, machine: S.machine
      };
    },
    __done: function () { walking = false; }
  };
})();
